import { User } from './index';

export class Membership {
  //#region Required properties JSON
  title: string;
  description: string;
  users: User[];
  //#endregion
}
